import React from 'react';
import { makeClassName } from '@siteless/util';

const SnailIcon = ({
  className,
  ...rest
}: {
  className?: string;
  [x: string]: unknown;
}) => (
  <svg
    className={makeClassName('SnailIcon', className)}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    <path d="M2 13a6 6 0 1 0 12 0 4 4 0 1 0-8 0 2 2 0 0 0 4 0" fill="none" />
    <circle cx="10" cy="13" r="8" fill="none" />
    <path d="M2 21h12c4.4 0 8-3.6 8-8V7a2 2 0 1 0-4 0v6" fill="none" />
    <path d="M18 3 19.1 5.2" fill="none" />
    <path d="M22 3 20.9 5.2" fill="none" />
  </svg>
);

export default SnailIcon;
